"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRadio = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var bcns = function (showBorder) {
    return (0, classnames_1.default)(
    // 'form-radio' is from Tailwind CSS Custom Forms (see config for package details)
    'br-form-radio', 'focus:br-border-blue-600', 'focus:br-shadow-blue', 'br-rounded-default', {
        'br-border-gray-500': showBorder,
        'br-border-white': !showBorder,
        'br-shadow': !showBorder
    });
};
var InputRadio = function (_a) {
    var className = _a.className, _b = _a.showBorder, showBorder = _b === void 0 ? true : _b, onChange = _a.onChange, unused = __rest(_a, ["className", "showBorder", "onChange"]);
    return (react_1.default.createElement("input", __assign({ type: "radio", className: (0, classnames_1.default)(bcns(showBorder), className), onChange: function (event) {
            event.stopPropagation();
            var target = event.target;
            onChange === null || onChange === void 0 ? void 0 : onChange(target.value);
        } }, unused)));
};
exports.InputRadio = InputRadio;
